// NOTE: some of the following keys is used in STATE_ID_TO_VIEW_NAME defined in OtherKeys.js file
export const PERSISTENCE_STATE_KEYS = {
  planResourceGridView: "b-plans-view-resources-state",
  remindersView: "b-reminders-view-state-v3",
  checklistView: "b-checklist-view-state-v2",
  boardSetting: "b-settings-board",
  boardSettingTeamGrid: "b-settings-tab-team-grid",
  boardSettingIncentiveTagCategoryGrid: "b-settings-tab-incentive-tag-category-grid",
  boardSettingIncentiveTagsGrid: "b-settings-tab-incentive-tags-grid",
  boardSettingResourceTypeGrid: "b-settings-resource-type-grid",
  taskEditorResourceTab: "b-task-editor-resource-tab",
  taskEditorPlansTab: "b-task-editor-plans-tab",
  clientHistoryGrid: "b-client-history-grid",
  resourceHistoryGrid: "b-resource-history-grid",
  editorTab: "b-editor-tab",
  resourceEditorReminderTab: "b-resource-editor-certifications-state-v4",
  globalSearch: "b-global-search",
  clientEditorReminderTab: "b-client-editor-reminder-state-v4",
  viewManagementEditorGrid: "b-view-management-editor-grid",
  lastSelectedBoardKey: "last-selected-view-state-on-board-v2",
  settingUserTab: "b-settings-user-tab-grid",
  taskStatusHistoryTab: "b-task-status-history-tab-v1",
  resourceEditorV2: "b-resource-editor-state-v3",
  clientEditorV2: "b-client-editor-state-v3",
  userEditor: "b-user-editor-state",
  contactEditor: "b-contact-editor-state",
  aboutEditor: "b-about-editor",
  taskBudgetGrid: "b-task-budget-grid",
  importEditor:"b-import-editor",
  settingsTabUserGrid: "b-settings-tab-user-grid",
  settingsTabBoardGrid: "b-settings-tab-board-grid",
  timelineOptionsGrid: "b-timeline-options-grid",
  timelineNonWorkingDaysGrid: "b-timeline-non-working-days-grid",
  clientChecklistGrid: "b-client-checklist-grid-v3",
  resourceChecklistGrid: "b-resource-checklist-grid-v3",
  allowedEmailNotifications: "AllowedNotifications",
  budgetMappedFieldsKey: "user-mapped-budget-fields-v2",
  resourceEditorNotifyGridState: "b-resource-editor-notify-grid-state",
  clientEditorNotifyGridState: "b-client-editor-notify-grid-state",
  resourceEditorNotesGridState: "b-resource-editor-notes-grid-state-v6",
  clientEditorNotesGridState: "b-client-editor-notes-grid-state-v6",
  richTextEditorPopup: "b-rich-text-editor-popup-state",
  resourceEditorContactGridState: "b-resource-editor-contact-grid-state",
  clientEditorContactGridState: "b-client-editor-contact-grid-state",
  userEditorContactGridState: "b-user-editor-contact-grid-state",
  contactNestedGridState: "b-contact-nested-grid-state",
  resourceEditorFilesGridState: "b-resource-editor-files-grid-state-v6",
  clientEditorFilesGridState: "b-client-editor-files-grid-state-v6",
  viewSelectedId: "view:view-selected-id",
  entityFinderEditor: "b-entity-finder-editor-state",
  settingPersonal: 'b-setting-personal',
  settingGeneral: 'b-setting-general',
  taskFinderEditor: "b-task-finder-editor-state",
  timelineConfiguratorEditor: "b-timeline-configurator-editor",
  timelineConfiguratorEditorTimescaleGridState: "b-timeline-configurator-editor-timescale-grid-state",
  timelineConfiguratorEditorNonWorkingDaysGridState: "b-timeline-configurator-editor-non-working-days-grid-state",
  timelineConfiguratorEditorSettingsGridState: "b-timeline-configurator-editor-settings-grid-state",
  checklistItemEditor: "checklist-item-editor-v3",
  checklistItemGrid: "checklist-item-grid-v1",
  viewOrganizerEditor: "b-view-organizer-editor-v1",
  viewOrganizerEditorGrid: "b-view-organizer-editor-grid-v2",
  shareViewsEditor: "b-share-views-editor-v1",
  viewFolderEditorGrid: "b-view-folder-editor-grid",
  boardAlertsEditor: "b-board-alerts-editor-v1",
  userDefaultEditPermission: "default-edit-permission",
  userDefaultViewPermission: "default-view-permission",
  budgetHoverOrder: "b-budget-hover-order-v2",
  budgetLabel: "b-budget-label-v2",
  budgetActualDays: "b-budget-actual-days",
  selectedRowHighlight: "b-selected-row-highlight",
  hoverGridCellHighlight: "b-hover-grid-cell-highlight",
  hoverTaskEventHighlight: "b-hover-task-event-highlight",
  resourceIconSize: "resource-icon-size",
  budgetEditor: "b-budget-editor",
  taskAutoArchiveEnabled: "is-task-auto-archive-enabled",
  taskAutoArchiveDays: "task-auto-archive-days",
  taskAutoArchiveStatusFilter: "task-auto-archive-statuses",
  mySwivuGrid: "b-myswivupage-view-2",
  enableRedundantTaskEvents: "b-enable-redundant-task-events",
  disableTimelineZoomOnMouse: "b-disable-timeline-zoomOnMouse",
  redistributeSubGridPanels: "b-redistribute-subGrid-panels",
  centerSchedulerLineOnToday: "b-center-scheduler-line-on-today",
  viewStatePIITS: "view-state-piits",
  viewInspectorEditor: "b-views-inpector-editor-v1",
  swivuAssistSheetUrl: "swivuAssistSheetUrl",
  swivuAssistLastUpdated: "swivuAssistLastUpdated",
  lastAwardTagId: "lastAwardTagId",
  personalSettingAlertsGridState: "b-personal-setting-alerts-grid-state",
  companyCamProjectEditor: "b-company-cam-project-editor",
  taskBudgetFocusMode: "task-budget-focus-mode",
  lastVisitedViews: "last_visited_views",
  timelineFiltersState: "timeline-filters-state",
  syncUserNotifyPreferenceChanges: "sync-user-notify-preference-changes",
  aiContextCardInDraft: "is-ai-context-card-in-draft",
  openAiApiKey: "open-ai-api-key",
  hasOpenAiApiKey: "has-open-ai-api-key",
  taskFilesEditor: "b-task-files-editor"
}
